
import { formatMoney } from "@/helpers";
import { Bar } from "vue-chartjs-typescript";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({
  extends: Bar
})
export default class PerformanceWeeklyGraph extends Vue {
  @Prop({ default: [] }) chartData!: any[];
  @Prop({ default: 140 }) height!: number;
  @Prop({ default: "100%" }) width!: String;

  public renderChart!: (chartData: any, options: any) => void;

  options = {
    animation: {
      duration: 0
    },
    parsing: false,
    tooltips: {
      callbacks: {
        afterBody: function(tooltipItem: any, data: any) {
          const index = tooltipItem[0].index;
          const commission_total = data.full_data[index].total_commissions;
          return `Commissions ${formatMoney(commission_total)}`;
        }
      }
    },
    legend: {
      display: false
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#7F95AA"
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            display: true
          },
          ticks: {
            beginAtZero: true,
            fontColor: "#7F95AA"
          }
        }
      ]
    }
  };

  @Watch("chartData")
  onDataChange(chartData: any[]) {
    if (chartData.length > 1) {
      const labels = chartData.map((data: any) => data.label);
      const data = chartData.map((data: any) => data.total_sales);
      const datasets = [
        {
          label: "Total Sales",
          backgroundColor: "#F4C172",
          data,
          barThickness: 24
        }
      ];
      const completeChartData = {
        labels,
        datasets,
        full_data: chartData
      };
      this.renderChart(completeChartData, this.options);
    }
  }
}
